<template>

  <div class="contents">
    <div class="content-wrap">
        <p class="headline">
          This page could not be found!
        </p>
        <p class="text">
          We are sorry. But the page you are looking for is not available.
        </p>
        <router-link to="/" class="button">BACK TO HOMEPAGE</router-link>
    </div>
  </div>
</template>

<script>


export default {
  name: 'NotFound',
  data: function() {
    return {
    }
  },
  components: {},
  methods:{
  },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  box-sizing: border-box;
}
.contents{
  margin:200px 0px;
  text-align: center;
}
.content-wrap{
  width:100%;
  max-width: 1024px;
  height:auto;
  margin: 0 auto;
  padding:20px;
}
.headline{
  font-size: 35px;
  color:#333;
}
.text{
  font-size: 18px;
  font-weight: 200;
  color: rgb(157, 157, 157);
}
.button{
  display: inline-block;
  background-color: #13aff0;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  margin: 0;
  padding: 14px 20px;
  border: 0;
  cursor: pointer;
  text-align: center;
  letter-spacing: 0.1em;
  line-height: 1;
  font-size: 13px;
  padding: 14px 26px;
  margin-top: 60px;
}
.button:hover{
  background-color: #087fb1;
}
a, a:hover, a:focus {
    text-decoration: none;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
}

</style>
